import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1034249f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "dialog__content" }

import { useEscapeEvent } from '@/utilities/UseEscapeEvent';
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';

interface Props {
	modalName: string;
	isOpen: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalDialog',
  props: {
    modalName: {},
    isOpen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const dialog = ref<HTMLDialogElement>();
const store = useStore();

const isDialogOpen = computed(() => props.isOpen);

const close = () => {
	store.commit('updateCurrentModalName', null);
};
const show = () => {
	dialog.value?.showModal();
};

// fire dialog close after transition has finished
function onAfterLeave() {
	dialog.value?.close();
}

watch(
	isDialogOpen,
	(open) => {
		if (open) {
			show();
		} else {
			close();
		}
	},
	{ immediate: true }
);

useEscapeEvent(close);

return (_ctx: any,_cache: any) => {
  const _component_focus_trap = _resolveComponent("focus-trap")!
  const _directive_scroll_lock = _resolveDirective("scroll-lock")!

  return (_openBlock(), _createElementBlock("dialog", {
    ref_key: "dialog",
    ref: dialog,
    class: "dialog",
    onClick: _withModifiers(close, ["self"])
  }, [
    _createVNode(_Transition, {
      name: "slide",
      onAfterLeave: onAfterLeave
    }, {
      default: _withCtx(() => [
        (isDialogOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_focus_trap, {
                active: isDialogOpen.value,
                "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((isDialogOpen).value = $event))
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default")
                  ])), [
                    [_directive_scroll_lock, true]
                  ])
                ]),
                _: 3
              }, 8, ["active"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}
}

})